export enum VehicleType {
  Bus = 'bus',
  Tram = 'tram',
  Car = 'car'
}
